import Model from './Model'

export default class Payment extends Model {
  resource () { return 'payments' }
}
